import React, { useCallback } from 'react';
import { Grid3x3, Eye } from 'lucide-react';
import { NodeType, NodeStatus } from '@/types';

interface TransformActionsProps {
  nodeId: string;
  nodeType: NodeType;
  status: NodeStatus;
  hasMedia: boolean;
  mediaType?: 'image' | 'video' | 'audio';
  images?: string[];
  onGridSplit?: (nodeId: string) => void;
  onPanorama?: (nodeId: string) => void;
}

export const TransformActions: React.FC<TransformActionsProps> = ({
  nodeId,
  nodeType,
  status,
  hasMedia,
  mediaType,
  images,
  onGridSplit,
  onPanorama,
}) => {
  const handleGridSplit = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    if (onGridSplit) onGridSplit(nodeId);
  }, [nodeId, onGridSplit]);

  const handlePanorama = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    if (onPanorama) onPanorama(nodeId);
  }, [nodeId, onPanorama]);

  if (!hasMedia) return null;

  return (
    <>
      {mediaType === 'image' && images && images.length > 1 && onGridSplit && (
        <button
          onClick={handleGridSplit}
          onMouseDown={(e) => e.stopPropagation()}
          title="九宫格切分"
          className="flex items-center justify-center w-9 h-9 rounded-md bg-transparent text-white hover:bg-white/15 transition-all cursor-pointer"
        >
          <Grid3x3 size={18} />
        </button>
      )}
      {mediaType === 'image' && nodeType === NodeType.PANORAMA_GENERATOR && onPanorama && (
        <button
          onClick={handlePanorama}
          onMouseDown={(e) => e.stopPropagation()}
          title="全景预览"
          className="flex items-center justify-center w-9 h-9 rounded-md bg-transparent text-white hover:bg-white/15 transition-all cursor-pointer"
        >
          <Eye size={18} />
        </button>
      )}
    </>
  );
};
